import { useState, useCallback } from "react";
import { fetchAllActiveUsersNonPaginated } from "../../service/UserService";

export const useActiveUsers = () => {
  const [userList, setUserList] = useState([]);
  const [error, setError] = useState(null);

  const fetchActiveUsers = useCallback(async () => {
    const result = await fetchAllActiveUsersNonPaginated();

    if (result?.success) {
      const users = result.data.map((user) => ({
        value: user.userId,
        label: `${user.firstName} ${user.lastName}`,
      }));
      setUserList(users);
      setError(null);
    } else {
      console.error("Error fetching active users:", result?.data);
      setUserList([]);
      setError(result?.data);
    }
  }, []); 

  return {
    userList,
    error,
    fetchActiveUsers,
  };
};